import React from 'react';

import classnames from 'classnames';

import { useSize, type SizeType } from '../../../features/config';
import { Skeleton, type SkeletonProps } from '../Skeleton';

import styles from '../Skeleton.module.scss';

export type SkeletonLineProps = Omit<SkeletonProps, 'height'> & {
    size?: SizeType;
};

export const SkeletonLine = ({ className, size, ...rest }: SkeletonLineProps) => {
    const mergedSize = useSize(size, 'small', 'SkeletonLine');
    return (
        <Skeleton
            className={classnames(styles.line, styles[mergedSize], className)}
            {...rest}
            height={undefined}
        />
    );
};
